//import md5 from "md5/md5";
import React from "react";
import { FormContext } from "./FormContext";

export default class Input extends React.Component {
	static contextType = FormContext;

	static id = 1;

	constructor(props) {
		super(props);

		this.type = props.type;
		let value = props.value;
		let decimals = 0;
		if (props.decimals)
			decimals = props.decimals;
		else if (props.currency) {
			decimals = 2;
			this.type = 'number';
			if (typeof value != 'undefined') {
				value = parseFloat(value);
				if (isNaN(value))
					value = null;
				else
					value = value.toFixed(decimals);
			}
		}
		this.pattern = props.pattern;
		if (this.type == "number" && !this.pattern) {
			this.type = "text";
			if (decimals == 0)
				this.pattern = "[\\-]?[0-9]*";
			else
				this.pattern = "[\\-]?[0-9]*[\.,]?[0-9]{1," + decimals + "}";
		}
		this.state = {
			value: typeof props.value == 'undefined' ? null : value,
			error: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.setValue = this.setValue.bind(this);
		this.setError = this.setError.bind(this);
		this.htmlId = "i" + Input.id++;
	}

	setValue(value) {
		this.setState({ value: value });
		this.context.setValue(this.props.name, value);
	}

	setError(error) {
		this.setState({ error: error });
	}

	handleChange(e) {
		let value = e.target.value;
		if (this.props.regex && value.match(this.props.regex) == null) {
			let pos = e.target.selectionStart - 1;
			setTimeout(() => e.target.selectionEnd = pos, 0);
			return;
		}
		this.setState({ value: value }, () => {
			if (this.props.onChange)
				this.props.onChange(e);
		});
		/*if (this.props.type == 'password')
			value = value ? md5(md5(value) + 'jacaliso.com') : null;
		else */if (this.props.type == 'number' || this.props.currency) {
			if (value == "")
				value = null;
			else
				value = Number(value.replace(',', '.'));
		}
		else if (this.props.type == 'file') {
			value = e.target.files;
		}
		this.context.setValue(this.props.name, value);
	}

	componentDidMount() {
		this.context.initInput(this.props.name, typeof this.props.value == 'undefined' ? null : this.props.value, this.setValue, this.setError);
		if (this.props.type == 'file')
			this.context.hasFiles();
	}

	componentWillUnmount() {
		this.context && this.context.removeInput(this.props.name);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value || prevProps.currency !== this.props.currency) {
			this.componentDidMount();
			this.setState({ value: this.props.value });
		}
	}

	render() {
		if (this.type == 'hidden')
			return null;
		// if (this.props.children)
		if (this.props.label)
			return (
				<div className={"mb-1" + ((this.props.children || this.props.currency) ? " input-group" : "")}>
					<div className={"form-floating" + (this.state.error ? " is-invalid" : "")}>
						<input type={this.type} step={this.props.step} value={this.state.value ?? ""}
							required={this.props.required} multiple={this.props.multiple} onChange={this.handleChange}
							disabled={this.props.readOnly || this.context.readOnly} maxLength={this.props.maxLength} min={this.props.min} max={this.props.max}
							pattern={this.pattern}
							className={"form-control" + (this.state.error ? " is-invalid" : "") + ((this.props.type == "number" || this.props.currency) ? " text-end" : "")}
							autoComplete="off" placeholder="" id={this.htmlId} />
						<label htmlFor={this.htmlId}>{this.props.label}</label>
					</div>
					{this.props.children ?
						this.props.children
						:
						this.props.currency ? <div className="input-group-text bottom">{t.currencies[this.props.currency][0]}</div> : null}
					{this.state.error && <div className="invalid-feedback">{this.state.error}</div>}
				</div>
			);
		else
			return (
				<div className={"mb-1" + (this.props.children ? " input-group" : "") + (this.state.error ? " is-invalid" : "")}>
					<input type={this.type} step={this.props.step} value={this.state.value ?? ""}
						required={this.props.required} multiple={this.props.multiple} onChange={this.handleChange}
						disabled={this.props.readOnly || this.context.readOnly} maxLength={this.props.maxLength} min={this.props.min} max={this.props.max}
						pattern={this.pattern}
						className={"form-control" + (this.state.error ? " is-invalid" : "") + (this.props.type == "number" ? " text-end" : "")}
						autoComplete="off" placeholder="" />
					{this.props.children && <div className="input-group-text">
						{this.props.children}
					</div>}
					{this.state.error && <div className="invalid-feedback">{this.state.error}</div>}
				</div>
			);

		//
		// return (
		//     <div className="input-group mb-1">
		//         <div className="form-floating">
		//             <input type={this.type} step={this.props.step} value={this.state.value ?? ""}
		//                    required={this.props.required} multiple={this.props.multiple} onChange={this.handleChange}
		//                    disabled={this.props.readOnly || this.context.readOnly} maxLength={this.props.maxLength} min={this.props.min} max={this.props.max}
		//                    pattern={this.pattern}
		//                    className="form-control"
		//                    autoComplete="off" placeholder="" id={this.htmlId}/>
		//             <label htmlFor={this.htmlId}>{this.props.label}</label>
		//         </div>
		//         {this.state.error && <div className="invalid-feedback">{this.state.error}</div>}
		//     </div>
		// );
		// return (
		//     <div className="row mb-3">
		//         <label htmlFor={this.htmlId} className="col-sm-2 col-form-label">{this.props.label}</label>
		//         <div className="col-sm-10">
		//             <input type={this.type} step={this.props.step} value={this.state.value ?? ""}
		//                    required={this.props.required} multiple={this.props.multiple} onChange={this.handleChange}
		//                    disabled={this.props.readOnly || this.context.readOnly} maxLength={this.props.maxLength} min={this.props.min} max={this.props.max}
		//                    pattern={this.pattern}
		//                    className="form-control"
		//                    autoComplete="off" placeholder="" id={this.htmlId}/>
		//             {this.state.error && <div className="invalid-feedback">{this.state.error}</div>}
		//         </div>
		//     </div>
		// );
		// return (
		//     <div className={"input" + (this.props.required && !this.state.value ? " required" : "") + (this.state.error ? " error" : "")}>
		//         {this.props.label && <label htmlFor={this.htmlId}>{this.props.label}</label>}
		//         <input type={this.type} step={this.props.step} value={this.state.value ?? ""}
		//                required={this.props.required} multiple={this.props.multiple} onChange={this.handleChange}
		//                disabled={this.props.readOnly || this.context.readOnly} maxLength={this.props.maxLength} min={this.props.min} max={this.props.max}
		//                pattern={this.pattern}
		//                className={"control" + ((this.props.type == " number" || this.props.currency) ? " right" : "")}
		//                autoComplete="off" id={this.htmlId}/>
		//         {this.unit && <div className="unit">{this.unit}</div>}
		//         {this.state.error && <output>{this.state.error}</output>}
		//     </div>
		// );
	}
}